import {
  BookAnAppointment,
  YourAppointments
} from './Screens'

const AppointmentsScreens = {
  BookAnAppointment: BookAnAppointment,
  YourAppointments: YourAppointments
}

export {
  BookAnAppointment,
  YourAppointments
}

export default AppointmentsScreens
